import React, { useContext, useEffect, useState } from "react";
import { Stack, Divider, Alert, Box, Button, Card, CardActions, CardHeader, Container, Grid, Paper, Typography, styled, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate, NavLink } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Grid container direction="column" alignItems="center" sx={{backgroundColor: '#77CABB', color: '#FFFFFF', py: {xs: 3, md: 5}}}>
          <Grid item xs={12}>
          {isMobile ? (
            <>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                sx={{ flexWrap: 'wrap' }}
              >
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/about')}>About</Button>
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/faq')}>FAQ</Button>
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/privacy')}>Privacy Policy</Button>
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/terms')}>Terms of Service</Button>
              </Stack>
              <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                sx={{ flexWrap: 'wrap', mt: 1 }}
              >
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/contact')}>Contact</Button>
                <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/ios-app')}>iOS App</Button>
              </Stack>
            </>
          ) : (
            <Stack
              direction="row"
              divider={<Divider sx={{bgcolor: '#FFFFFF', my: '8px !important'}} orientation="vertical" flexItem />}
              spacing={1}
            >
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/about')}>About</Button>
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/faq')}>FAQ</Button>
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/privacy')}>Privacy Policy</Button>
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/terms')}>Terms of Service</Button>
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/contact')}>Contact</Button>
              <Button variant="text" sx={{color: '#FFFFFF', textTransform: 'none'}} onClick={() => navigate('/ios-app')}>iOS App</Button>
            </Stack>
          )}
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 1 }}>
                <NavLink to="/ios-app" style={{ textDecoration: 'none' }} key="appstore">
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/2560px-Download_on_the_App_Store_Badge.svg.png"
                    alt="Download on the App Store"
                    style={{ height: 30 }}
                />
                </NavLink>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{py:1}}>
              {'Copyright © '}{`${new Date().getFullYear()} Living Waters. All rights reserved.`}
            </Typography>
          </Grid>
        </Grid>
    )
}
